export const IS_CALL_BEEP_ENABLED = !['false', 'no', '0'].includes(
  String(process.env.REACT_APP_CALL_BEEP_ENABLED || '')
    .trim()
    .toLowerCase()
);

let audioContext;

export const initAudioContext = () => {
  if (!IS_CALL_BEEP_ENABLED) return;

  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }

  if (audioContext.state === 'suspended') {
    audioContext.resume();
  }
};

export const playBeep = () => {
  if (!IS_CALL_BEEP_ENABLED) return;

  if (!audioContext) return;

  const oscillator = audioContext.createOscillator();
  const gainNode = audioContext.createGain();
  const now = audioContext.currentTime;

  oscillator.type = 'sine';
  oscillator.frequency.setValueAtTime(480, now);

  // Smooth fade in
  gainNode.gain.setValueAtTime(0, now);
  gainNode.gain.linearRampToValueAtTime(0.18, now + 0.05);

  // Smooth fade out
  gainNode.gain.linearRampToValueAtTime(0, now + 1.3);

  oscillator.connect(gainNode);
  gainNode.connect(audioContext.destination);

  oscillator.start(now);
  oscillator.stop(now + 1.3);
};
